import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const markets = [
  {
    region: 'Tampa Bay Area',
    cities: ['Tampa', 'St. Petersburg', 'Clearwater', 'Brandon', 'Bradenton', 'Sarasota', 'Lakeland', 'Dunedin'],
  },
  {
    region: 'Central Florida / Orlando',
    cities: ['Orlando', 'Kissimmee', 'Sanford', 'Winter Park', 'Altamonte Springs', 'Clermont', 'Deltona', 'Oviedo'],
  },
  {
    region: 'South Florida',
    cities: ['Miami', 'Fort Lauderdale', 'West Palm Beach', 'Boca Raton', 'Coral Springs', 'Hollywood', 'Pompano Beach', 'Deerfield Beach'],
  },
  {
    region: 'Southwest Florida',
    cities: ['Fort Myers', 'Cape Coral', 'Naples', 'Bonita Springs', 'Estero', 'Port Charlotte', 'Punta Gorda', 'Marco Island'],
  },
  {
    region: 'Northeast Florida',
    cities: ['Jacksonville', 'St. Augustine', 'Orange Park', 'Fernandina Beach', 'Palatka', 'Gainesville', 'Ocala', 'Daytona Beach'],
  },
];

const ServiceAreasPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="bg-[#0C2340] py-20 nav-offset">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-[#C41E3A] text-sm font-bold uppercase tracking-widest mb-3">Service Areas</p>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-5">Proudly Serving Florida</h1>
          <p className="text-base sm:text-xl text-white/75 max-w-2xl mx-auto">From Tampa Bay to South Florida, we provide expert home comfort services across the entire state.</p>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-white border-b border-[#E2E8F0]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-3 gap-6 text-center">
            {[
              { icon: 'ri-map-pin-2-fill', value: '5 Regions', label: 'Florida Coverage' },
              { icon: 'ri-building-2-fill', value: '40+', label: 'Cities Served' },
              { icon: 'ri-customer-service-2-fill', value: '24/7', label: 'Emergency Service' },
            ].map((s) => (
              <div key={s.label} className="p-6 bg-[#F8F9FB] rounded-xl border border-[#E2E8F0]">
                <div className="w-12 h-12 bg-[#C41E3A]/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <i className={`${s.icon} text-2xl text-[#C41E3A]`} />
                </div>
                <p className="text-2xl sm:text-3xl font-bold text-[#0C2340] mb-1">{s.value}</p>
                <p className="text-sm text-[#6B7280]">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 sm:py-16 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <div className="mb-12 rounded-2xl overflow-hidden border border-[#E2E8F0]">
            <iframe
              title="Renova Florida Service Areas"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3628947.8!2d-81.5158!3d27.6648!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c1766591562abf%3A0xf72e13d35bc74ed0!2sFlorida!5e0!3m2!1sen!2sus!4v1234567890"
              width="100%"
              height="360"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full"
            />
          </div>

          <div className="space-y-10">
            {markets.map((m) => (
              <div key={m.region}>
                <h2 className="text-lg sm:text-xl font-bold text-[#111827] mb-4 pb-3 border-b border-[#E2E8F0] flex items-center space-x-2">
                  <i className="ri-map-pin-fill text-[#C41E3A]" />
                  <span>{m.region}</span>
                </h2>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                  {m.cities.map((city) => (
                    <button
                      key={city}
                      onClick={() => navigate('/book-appointment')}
                      className="flex items-center space-x-2 p-3 bg-[#F8F9FB] hover:bg-[#FEF2F2] rounded-lg border border-[#E2E8F0] hover:border-[#C41E3A]/30 transition-all cursor-pointer text-left"
                    >
                      <i className="ri-map-pin-line text-[#C41E3A] text-sm flex-shrink-0" />
                      <span className="text-sm text-[#374151] font-medium">{city}, FL</span>
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-14 sm:mt-16 bg-[#0C2340] rounded-2xl p-8 sm:p-10 text-center">
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4">Don&apos;t See Your City?</h2>
            <p className="text-white/70 mb-6 max-w-xl mx-auto">We&apos;re growing across Florida. Give us a call or enter your zip code to check if we serve your area.</p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <button onClick={() => navigate('/book-appointment')} className="bg-[#C41E3A] text-white px-7 py-3.5 rounded-lg text-sm font-semibold hover:bg-[#A01830] transition-colors whitespace-nowrap cursor-pointer">
                Check My Zip Code
              </button>
              <a href="tel:+18506698335" className="border border-white/30 text-white px-7 py-3.5 rounded-lg text-sm font-semibold hover:bg-white/10 transition-colors whitespace-nowrap">
                Call (850) 669-8335
              </a>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default ServiceAreasPage;